module.exports = __webpack_public_path__ + "co.svg?ca05f9f988e26ed6e1f3a300bae318fe";